import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import merge from 'lodash/merge';
import FormWrapper from './containers/FormWrapper';
import SimpleHeader from '../../headers/simpleHeader';
import * as actions from './actions';
import * as shapes from './shapes';
import { getBaseUrl } from './helpers';
import { trimFunction } from '../../../common/trimData';
import {
  getShop,
  getShops,
  isBrandViewActive,
  getBarberUser,
  getActiveBrandId,
} from '../../../auth/selectors';
import { withActionByRole } from '../../../common/helpers/actions';
import withNotifications from '../../../common/withNotifications';

const initialValues = {
  addToPrice: true,
  enabled: false,
  externalOrdersOnly: false,
};

const Add = ({ onSubmit, baseUrl }) => (
  <div>
    <SimpleHeader heading="Add tax" />
    <FormWrapper
      onSubmit={trimFunction(onSubmit)}
      baseUrl={baseUrl}
      initialValues={initialValues}
    />
  </div>
);

Add.propTypes = {
  onSubmit: shapes.handler.isRequired,
  baseUrl: shapes.url.isRequired,
};

const mapStateToProps = state => ({
  shop: getShop(state),
  shops: isBrandViewActive(state) ? getShops(state) : [],
  barberUser: getBarberUser(state),
  brandId: getActiveBrandId(state),
  isBrandUser: isBrandViewActive(state),
  baseUrl: getBaseUrl(state.auth.barberUser, isBrandViewActive(state)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const props = { ...ownProps, ...stateProps, ...dispatchProps };

  const onSubmitPromiseListener = action => async (...args) => {
    const response = await action(...args);
    if (props.isBrandUser) {
      props.router.replace(`${props.baseUrl}/${response.id}/edit`);
    } else {
      props.router.replace(props.baseUrl);
    }
    props.addNotification({
      level: 'success',
      message: 'Tax saved successfully.',
      title: 'Success',
    });
  };

  if (props.isBrandUser) {
    return merge(props, {
      onSubmit: onSubmitPromiseListener(data => props.addTax(merge(data, {
        shops: props.shops.reduce((acc, { id }) => merge(acc, {
          [id]: { id },
        }), {}),
      }))),
    });
  }

  return merge(props, {
    onSubmit: onSubmitPromiseListener(props.addTax),
  });
};

export default compose(
  withRouter,
  withNotifications,
  withActionByRole(
    'addTax', actions.addShopTax, actions.addBarberTax, actions.addBrandTax,
  ),
  connect(mapStateToProps, {}, mergeProps)
)(Add);
